export default __webpack_public_path__ + "static/media/franco.6c11b7a0.jpeg";